const awsmobile = {
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_PP2mrEDza",
    "aws_user_pools_web_client_id": "7fhfn3438lo7m662ndsg9dtrsu",
};


export default awsmobile;